import script from "./AddModal.vue?vue&type=script&setup=true&lang=js"
export * from "./AddModal.vue?vue&type=script&setup=true&lang=js"

import "./AddModal.vue?vue&type=style&index=0&id=552115b0&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-552115b0"]])

export default __exports__